import { render, staticRenderFns } from "./UserInitials.vue?vue&type=template&id=c0a1cee0&scoped=true&"
import script from "./UserInitials.vue?vue&type=script&lang=ts&"
export * from "./UserInitials.vue?vue&type=script&lang=ts&"
import style0 from "./UserInitials.vue?vue&type=style&index=0&id=c0a1cee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a1cee0",
  null
  
)

export default component.exports